import classNames from "classnames";
import { Rune } from "@outplayed/tooltips";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useGlobal } from "reactn";

interface RuneTreeCondensedProps {
  perkStyle: number;
  activePerks: number[];
  patch: string;
  pathLabel?: boolean;
  ssr?: boolean;
}

export function RuneTreeCondensed(props: RuneTreeCondensedProps) {
  const { pathLabel, perkStyle, activePerks, patch, ssr } = props;
  const { getRuneJSON, useRiotRunes } = getRiotAssetsContext();
  const [language] = useGlobal("language");
  const { data, loading, error } = useRiotRunes({ patch, ssr, language });

  const buildPerks = () => {
    const path = data?.find((path) => {
      return path.id === perkStyle;
    })?.slots;
    let perksToDisplay: JSX.Element[] = [];

    path?.forEach((row, index) => {
      row.runes.forEach((perk) => {
        if (activePerks.includes(perk.id)) {
          perksToDisplay.push(
            <div key={perk.id}>
              <Rune
                className={classNames("max-w-[unset] w-[20px]", { "!w-[26px]": index === 0 })}
                runeId={perk.id}
                patch={patch}
                ssr={ssr}
              />
            </div>,
          );
        }
      });
    });

    return perksToDisplay;
  };

  if (!data) {
    return null;
  }
  const runeJSON = getRuneJSON(perkStyle, { optionalData: data });

  return (
    <div
      className={classNames("grid grid-cols-[122px_1fr]", {
        "grid-cols-[auto_1fr]": !pathLabel,
      })}
    >
      <div className="flex items-center col-start-1 col-end-2">
        <Rune className="w-[30px] mr-[8px]" runeId={perkStyle} patch={patch} ssr={ssr} disableTooltip />
        {pathLabel && <div className="text-[12px] font-bold">{runeJSON.name}</div>}
      </div>
      <div className="flex items-center gap-[6px] col-start-2 col-end-3">{buildPerks()}</div>
    </div>
  );
}
